import { createSelector } from 'reselect'

/**
 * Gets the user with the given `name`.
 * @param  {string} name
 * @returns {Selector}
 */
function getUserSelector (name) {
  return createSelector(
    state => state && state.users,
    users => users.data[name]
  )
}

export default getUserSelector
